/**
 * Created by zhangjinjie on 2017/5/17.
 */
export var SET_USER = 'auth/SET_USER';
export var SET_TOKEN = 'auth/SET_TOKEN';
export var SET_REFRESH_TOKEN = 'auth/SET_REFRESH_TOKEN';
export var CLEAR_TOKENS = 'auth/CLEAR_TOKENS';
export var SET_APPKEY = 'auth/SET_APPKEY';


//////////////////
// WEBPACK FOOTER
// ./~/vue-hamlet/lib/store/types.js
// module id = 218
// module chunks = 0